// @flow
import type { GEO_POINT_TYPE } from './common';


export type NEW_STOP_MARKER_ADDED_TYPE = {
  type: 'NEW_STOP_MARKER_ADDED',
  payload: GEO_POINT_TYPE
};
export const NEW_STOP_MARKER_ADDED = 'NEW_STOP_MARKER_ADDED';

export type NEW_STOP_MARKER_REPOSITIONED_TYPE = {
  type: 'NEW_STOP_MARKER_REPOSITIONED',
  payload: GEO_POINT_TYPE
};
export const NEW_STOP_MARKER_REPOSITIONED = 'NEW_STOP_MARKER_REPOSITIONED';

export type NEW_STOP_MARKER_REMOVED_TYPE = {
  type: 'NEW_STOP_MARKER_REMOVED'
};
export const NEW_STOP_MARKER_REMOVED = 'NEW_STOP_MARKER_REMOVED';

export type NEW_STOP_MARKER_ACTION_TYPE =
  | NEW_STOP_MARKER_ADDED_TYPE
  | NEW_STOP_MARKER_REPOSITIONED_TYPE
  | NEW_STOP_MARKER_REMOVED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/newStopMarker.js